<template>
    <div v-if="offer" class="product-wrapper">
        <div class="offer product">
            <div class="product-header">
                <div class="network">
                    <h4 class="selected-net text-default fw-bold mb-0">
                        Los Toestel
                    </h4>
                </div>

                <div class="discount-overview px-3 py-1 content-default highlight">
                    <h4 class="mb-0">{{ offer.device.brand }}</h4>
                    <p>Toestel zonder mobiel abonnement</p>
                </div>
            </div>

            <div class="product-preview">
                <div class="product-details-wrap">
                    <div class="product-image single">
                        <a :href="offerUrl">
                            <img v-if="offer.image" :src="offer.image.thumb" class="product-display" :alt="offer.device.display_name">
                            <img v-else src="/images/no-image.jpg" class="product-display" :alt="offer.device.display_name">
                        </a>
                    </div>
                </div>

                <div class="product-title" :title="offer.device.display_name">
                    {{ offer.device.display_name }}
                </div>
            </div>

            <div class="offer-preview">
                <div class="offer-details availability-in-stock">
                    <div class="delivery">
                        <span v-if="!parseFloat(offer.shipping_costs)">
                            {{ offer.delivery_details.time }}, gratis verzending
                        </span>

                        <span v-else>
                            {{ offer.delivery_details.time }}
                        </span>
                    </div>

                    <div class="under-line-color">
                        <div class="under-last">
                            <div class="offer single-offer">
                                <multiselect
                                    v-model="deviceColor"
                                    :options="colorOptions"
                                    :searchable="false"
                                    :allowEmpty="false"
                                    :canClear="false"
                                    @select="onColorChange"
                                />
                            </div>

                            <div class="price">
                                <div>
                                    <div class="price-amount">
                                        <div v-if="oneTimePrice > 0" class="price-text">eenmalig</div>
                                        <div v-else class="price-text">cashback</div>

                                        <div class="price-value">
                                            {{ $filters.formatDecimals(oneTimePrice) }}
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div class="price-amount">
                                        <div class="price-text">per maand</div>
                                        <div class="price-value">
                                            {{ $filters.formatDecimals(0) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="btn-order-wrap">
                <div class="btn-order"
                     @mouseover="isHovering = true"
                     @mouseleave="isHovering = false"
                     :class="[isHovering ? `content-default` : '']"
                >
                    <a :href="offerUrl">
                        Bekijk
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from "@vueform/multiselect"

export default {
    components: {
        Multiselect
    },

    props: {
        offers: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            isHovering: false,
            deviceColor: null,
        }
    },

    watch: {
        offers: {
            handler(newValue, oldValue) {
                this.deviceColor = null
            },
        }
    },

    computed: {
        offer() {
            if (!this.deviceColor) {
                let offer = this.offers.find(el => el.device.is_main_color)
                offer = offer || this.offers[0]

                this.deviceColor = offer.device.color

                return offer
            }

            return this.offers.find(el => el.device.color === this.deviceColor)
        },

        oneTimePrice() {
            return parseFloat(this.offer.price) + parseFloat(this.offer.shipping_costs)
        },

        offerUrl() {
            return `${this.offer.url}?color=${this.offer.device.color}`
        },

        colorOptions() {
            return this.offers
                .map(el => el.device.color)
                .filter((el, index, array) => array.indexOf(el) === index)
        }
    },

    methods: {
        onColorChange(option) {
            this.deviceColor = option
        },
    }
}
</script>
